import { useTranslation } from "react-i18next"
import { STATUS_IDS } from "../../constants/common"
import { cn } from "../../utils/cn"

const Header = ({ title, data }: {
    title: string;
    data: {
        n_ApprovalStatus: number;
        s_ApprovalStatus_En: string;
        s_ApprovalStatus_Ar: string;
    }
}) => {
    const { i18n } = useTranslation()

    return (
        <div className="flex items-center gap-2">
            <h1 className="text-xl md:text-2xl dark:text-white">
                {title}
            </h1>

            {data &&
                data?.n_ApprovalStatus !== STATUS_IDS.PENDING && (
                    <p
                        className={cn(
                            "text-[13px]",
                            data?.n_ApprovalStatus === STATUS_IDS.APPROVED
                                ? "text-green-600"
                                : "text-red-600"
                        )}
                    >
                        (
                        {i18n.language === "en"
                            ? data?.s_ApprovalStatus_En
                            : data?.s_ApprovalStatus_Ar}
                        )
                    </p>
                )}
        </div>
    )
}

export default Header
